import { render } from "./paySignUpPaid.vue?vue&type=template&id=6632af19&scoped=true"
import script from "./paySignUpPaid.vue?vue&type=script&lang=js"
export * from "./paySignUpPaid.vue?vue&type=script&lang=js"

import "./paySignUpPaid.vue?vue&type=style&index=0&id=6632af19&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6632af19"]])

export default __exports__